'use strict';

var creditsSimulation = {
    init: function () {
        this.slickSlider('item-MPV');
        this.hitungSimulasi();
        this.konsultasiPembelian();
        this.clicksByModel();

        // result simulation default
        $('.uangMuka').css('display', 'none');
        $('.cicilanBulanan').css('display', 'none');
        // first load list car
        this.checkDataCars();
        document.querySelector('.credits-content').style.display = 'none';
    },
    listDealerId: function () {
        document.querySelector("#otrs").value;
        return document.querySelector("#dealer_id").value;
    },
    listCityId:function () {
        document.querySelector("#otrs").value;
        return document.querySelector("#city_id").value;
    },
    checkDataCars: function () {
        $.ajax({
            url: creditsSimulation.urlMain() + '/credits-check-cars',
            type: "POST",
            data: {
                'dealer_id': creditsSimulation.listDealerId(),
                'city_id': creditsSimulation.listCityId(),
            },
            beforeSend: function (xhr) {
                // do something
                document.querySelector(".credit-simulation").style.visibility = "hidden";
            },
            success: function (result) {
                let data = result;
                var dataCars = data.dataCars;
                let btn_category = document.querySelector('.category-vehicle');
                let slick = document.querySelector('._credits-list-car');
                let count_btn = 0;
                let hasCar = false;
                $.each(dataCars, function (i, obj) {
                    let body = i;
                    if (obj >= 1) {
                        if (count_btn == 0) {
                            btn_category.innerHTML += `<button class="btn btn-${i} active" id="btns-${i}" data-body="${i}">${body.replace('-', ' ')}</button>`;
                            creditsSimulation.getListCars('' + i + '', 1);
                            hasCar = true;
                        } else {
                            btn_category.innerHTML += `<button class="btn btn-${i}" id="btns-${i}" data-body="${i}">${body.replace('-', ' ')}</button>`;
                        }
                        count_btn++;
                    }
                });

                if (!hasCar) {
                    slick.innerHTML = `
                        <div id="_credits-content-0" class="data-content">
                            <div class="slider slider-nav">
                                <div class="text-center">Mohon Maaf, Kredit Simulasi Untuk Saat Ini Belum Tersedia</div>
                            </div>
                        </div>
                    `;
                } else {
                    slick.innerHTML += `
                        <div id="_credits-content-0" class="data-content">
                            <div class="slider slider-nav">

                            </div>
                        </div>
                    `;
                }

                document.querySelector(".credit-simulation").style.visibility = "visible";
            },
            error: function (xhr, ajaxOptions, thrownError) {
                document.querySelector(".credit-simulation").style.visibility = "visible";
            }
        });
    },
    slickSlider: function (countItems) {
        $('.slider-nav').not('.slick-initialized').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            dots: false,
            focusOnSelect: true,
            centerMode: true,
            infinite: false,
            arrows: false,
            // prevArrow: "<img class='slick-prev mCategory' src='images/slick-left-arrow.png'>",
            // nextArrow: "<img class='slick-next mCategory' src='images/slick-right-arrow.png'>",
            variableWidth: true,
            initialSlide: creditsSimulation.count(countItems),
            draggable: false,
            responsive: [
                {
                    breakpoint: 980,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    },
    count: function (count) {
        var no = 0;
        document.querySelectorAll("." + count).forEach((items) => {
            no++;
        });
        var h = no / 2;

        return parseInt(h);
    },
    hitungSimulasi: function () {
        document.querySelector("#hitungSimulasi").addEventListener("click", function (e) {
            e.preventDefault();

            const brVariant = document.querySelector("#variant");
            const brKota = document.querySelector("#city");
            const brPilihan = document.querySelector("#pilihan");

            $.ajax({
                url: creditsSimulation.urlMain() + '/credits-hitung-simulasi',
                type: "POST",
                data: {
                    'type_id': brVariant.value,
                    'city_id': brKota.value,
                    'dealer_id': creditsSimulation.listDealerId(),
                },
                beforeSend: function (xhr) {

                },
                success: function (result) {
                    // result simlulation inputs
                    let data = result;
                    document.querySelector("._credits-result-simulasi").style.display = 'block';
                    let otr = data.typeModel[0].price.replace('IDR.', 'Rp.');
                    $("#otrs").val(otr);
                    $("#title-price").html(otr);
                    $("#administrasi").val(data.typeModel[0].option.administration);
                    $("#asuransi").val(data.typeModel[0].option.insurance);
                    $("#bunga").val(data.typeModel[0].option.interest);
                    $("#provisi").val(data.typeModel[0].option.provision);
                    let option = "<option value='' selected>Pilih Tenor</option>";
                    for (var key in data.typeModel[0].tenor) {
                        let tenor = data.typeModel[0].tenor[key].tenor * 12;
                        option += `
                            <option value="${tenor}">${tenor} Bulan</option>
                        `;
                    }
                    $("#tenors").html(option);

                    const tdpUm = document.querySelector("#tdpUm");
                    const cicilanCb = document.querySelector("#cicilanCb");
                    if (brPilihan.value == "uang muka") {
                        $('.uangMuka').css('display', 'block');
                        $('.cicilanBulanan').css('display', 'none');
                        tdpUm.focus();

                        document.querySelector('.alerts_tdpUm').style.display = 'none';
                        document.querySelector('.alerts_tenors').style.display = 'none';
                    } else if (brPilihan.value == "cicilan bulanan") {
                        $('.uangMuka').css('display', 'none');
                        $('.cicilanBulanan').css('display', 'block');
                        cicilanCb.focus();
                        document.querySelector('.alerts_cicilanCb').style.display = 'none';
                        document.querySelector('.alerts_tenors').style.display = 'none';
                    } else {
                        $('.uangMuka').css('display', 'none');
                        $('.cicilanBulanan').css('display', 'none');
                    }
                }
            });
        });
    },
    konsultasiPembelian: function () {
        document.querySelector("#KonsultasiPembelian").addEventListener("click", function (e) {
            e.preventDefault();

            if ($("#web_dealer").val() == 1) {
                window.location.href = '/konsultasi';
            } else {
                window.open('https://www.toyota.astra.co.id/shopping-tools/konsultasi-pembelian', '_blank');
            }
        });
    },
    urlMain: function () {
        return window.location.href;
    },
    getListCars: function (bodyName) {
        $.ajax({
            url: creditsSimulation.urlMain() + '/credits-listcar',
            type: "POST",
            data: {
                'bodyType': bodyName,
                'dealer_id': creditsSimulation.listDealerId(),
                'city_id': creditsSimulation.listCityId()
            },
            beforeSend: function (xhr) {
                
            },
            success: function (result) {
                let data = result.data;
                let list_car = document.querySelector('#_credits-content-0 .slider-nav');
                list_car.innerHTML = '';
                $.each(data, function (i, obj) {
                    list_car.innerHTML += `
                        <div class="small-thumb">
                            <div class="items-slick item-${obj.model_body}" data-otr="${obj.otr}" data-image="${obj.image}" data-body="${obj.model_body}" data-model="${obj.model_id}" data-model-name="${obj.model_name}">
                                <img src="${obj.image}" alt="">
                                <span>${obj.model_name}</span>
                            </div>
                        </div>
                    `;
                });
                creditsSimulation.slickSlider('item-' + data[0].model_body);
                $('.otr-credit').html($(".slick-current .items-slick").attr("data-otr"));
                $('.img-credit').attr("src", $(".slick-current .items-slick").attr("data-image"));
                $('.model-name-credit').html($(".slick-current .items-slick").attr("data-model-name"));
                document.querySelector('._credits-list-car').style.display = 'block';
                creditsSimulation.getListCarsBytype($(".slick-current .items-slick").attr("data-model"));
            }
        });
    },
    getListCarsBytype(id) {
        $.ajax({
            url: creditsSimulation.urlMain() + '/credits-listcar-bytype',
            type: "POST",
            data: {
                'model_id': id,
                'bodyType': $(".slick-current .items-slick").attr("data-body"),
                'dealer_id': creditsSimulation.listDealerId(),
                'city_id': creditsSimulation.listCityId()
            },
            beforeSend: function (xhr) {
                // do something

            },
            success: function (result) {
                let data = result.data;
                let lis_variant = document.querySelector('#variant');
                let list_city = document.querySelector('#city');
                $.each(data.type, function (i, obj) {
                    lis_variant.innerHTML += `<option value="${obj.type_id}">${obj.type_name}</option>`;
                });

                $.each(data.city, function (i, obj) {
                    list_city.innerHTML += `<option value="${obj.city_id}">${obj.city_name}</option>`;
                });
                document.querySelector('.credits-content').style.display = 'flex';
            }
        });
    },
    clicksByModel: function () {
        $(".small-thumb").trigger('click');
    },
    rumusUM: function (params) {
        console.log(params);
        let adm = params['tdp'] + params['adm'] + params['ass'];
        let pembagi = (params['otr'] - adm) * (1 + (params['bunga'] / 100));
        let dibagi = (params['tenor'] * (1 - (params['provisi'] / 100))) - (1 + (params['bunga'] / 100));
        let hasil = pembagi / dibagi;
        if (hasil < 0) { hasil = 0; }
        return hasil;
    },
    rumusCB: function (params) {
        console.log(params);
        let pembagi = params['cicilan'] * params['tenor'];
        let dibagi = 1 + (params['bunga'] / 100);
        let hasil = params['otr'] - (pembagi / dibagi);
        if (hasil < 0) { hasil = 0; }
        return hasil;
    },
    isNumberKey: function (evt) {
        var charCode = (evt.which) ? evt.which : event.keyCode
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            return false;
        }
        return true;
    },
    convertToRupiah: function (angka) {
        let number = parseInt(angka);
        var rupiah = '';
        var angkarev = number.toString().split('').reverse().join('');
        for (var i = 0; i < angkarev.length; i++) if (i % 3 == 0) rupiah += angkarev.substr(i, 3) + '.';
        return 'Rp. ' + rupiah.split('', rupiah.length - 1).reverse().join('');
    },
}


$(document).ready(function () {

    creditsSimulation.init();

});

document.querySelector('.category-vehicle').addEventListener('click', function (event) {
    console.log('click');
    if (event.target.tagName.toLowerCase() === 'button') {
        document.querySelector('._credits-result-simulasi').style.display = 'none';
        document.querySelector('#variant').innerHTML = '<option value="">Pilih Variant</option>';
        document.querySelector('#city').innerHTML = '<option value="">Pilih Kota</option>';
        document.querySelector('.category-vehicle button.active').classList.remove('active');
        document.querySelector('._credits-list-car').style.display = 'none';
        $('.slider-nav').slick('unslick');
        let bodyName = $("#" + event.target.id).attr("data-body");
        let btn = document.querySelector("#" + event.target.id);
        document.querySelector('.credits-content').style.display = 'none';
        btn.classList.add('active');
        creditsSimulation.getListCars(bodyName);
    }
});

$(document).on("click", ".small-thumb", function () {
    document.querySelector('#variant').innerHTML = '<option value="">Pilih Variant</option>';
    document.querySelector('#city').innerHTML = '<option value="">Pilih Kota</option>';
    $('.otr-credit').html($(".slick-current .items-slick").attr("data-otr"));
    $('.img-credit').attr("src", $(".slick-current .items-slick").attr("data-image"));
    $('.model-name-credit').html($(".slick-current .items-slick").attr("data-model-name"));
    document.querySelector('._credits-result-simulasi').style.display = 'none';
    creditsSimulation.getListCarsBytype($(".slick-current .items-slick").attr("data-model"));
});

$(document).on("change", "#tenors", function () {
    let otrs = document.querySelector("#otrs").value;
    let otr = otrs.replace('Rp. ', '');
    let tdpUm = document.querySelector("#tdpUm").value.replace('Rp. ', '');
    let cicilanCb = document.querySelector("#cicilanCb").value.replace('Rp. ', '');
    let tenors = document.querySelector("#tenors").value;
    let adm = document.querySelector("#administrasi").value;
    let ass = document.querySelector("#asuransi").value;
    let bunga = document.querySelector("#bunga").value;
    let provisi = document.querySelector("#provisi").value;
    let pilihan = document.querySelector("#pilihan").value;

    var params = new Object;
    params['otr'] = parseInt(otr.replaceAll('.', ''));
    params['adm'] = parseInt(adm);
    params['ass'] = parseInt((ass / 100) * otr.replaceAll('.', ''));
    params['bunga'] = bunga;
    params['tenor'] = parseInt(tenors);
    params['provisi'] = parseInt(provisi);

    if (pilihan == "uang muka") {
        params['tdp'] = parseInt(tdpUm.replaceAll('.', ''));
        var data = creditsSimulation.rumusUM(params);
        $("#cicilanUm").val(creditsSimulation.convertToRupiah(data));
    } else if (pilihan == "cicilan bulanan") {
        params['cicilan'] = parseInt(cicilanCb.replaceAll('.', ''));
        var data = creditsSimulation.rumusCB(params);
        $("#tdpCb").val(creditsSimulation.convertToRupiah(data));
    } else {

    }
});


/* Tanpa Rupiah */
var tdpUm = document.getElementById('tdpUm');
tdpUm.addEventListener('keyup', function (e) {
    tdpUm.value = formatRupiah(this.value, 'Rp.');
    let tenor = $("#tenors").val();
    if (tenor !== "") {
        let otrs = document.querySelector("#otrs").value;
        let otr = otrs.replace('Rp. ', '');
        let tdpUm = document.querySelector("#tdpUm").value.replace('Rp. ', '');
        let tenors = document.querySelector("#tenors").value;
        let adm = document.querySelector("#administrasi").value;
        let ass = document.querySelector("#asuransi").value;
        let bunga = document.querySelector("#bunga").value;
        let provisi = document.querySelector("#provisi").value;
        var params = new Object;
        params['otr'] = parseInt(otr.replaceAll('.', ''));
        params['adm'] = parseInt(adm);
        params['ass'] = parseInt((ass / 100) * otr.replaceAll('.', ''));
        params['bunga'] = bunga;
        params['tenor'] = parseInt(tenors);
        params['provisi'] = parseInt(provisi);
        params['tdp'] = parseInt(tdpUm.replaceAll('.', ''));
        var data = creditsSimulation.rumusUM(params);
        $("#cicilanUm").val(creditsSimulation.convertToRupiah(data));
    }
});

var Cb = document.getElementById('cicilanCb');
Cb.addEventListener('keyup', function (e) {
    Cb.value = formatRupiah(this.value, 'Rp.');
    let tenor = $("#tenors").val();
    if (tenor !== "") {
        let otrs = document.querySelector("#otrs").value;
        let otr = otrs.replace('Rp. ', '');
        let cicilanCb = document.querySelector("#cicilanCb").value.replace('Rp. ', '');
        let tenors = document.querySelector("#tenors").value;
        let adm = document.querySelector("#administrasi").value;
        let ass = document.querySelector("#asuransi").value;
        let bunga = document.querySelector("#bunga").value;
        let provisi = document.querySelector("#provisi").value;
        var params = new Object;
        params['otr'] = parseInt(otr.replaceAll('.', ''));
        params['adm'] = parseInt(adm);
        params['ass'] = parseInt((ass / 100) * otr.replaceAll('.', ''));
        params['bunga'] = bunga;
        params['tenor'] = parseInt(tenors);
        params['provisi'] = parseInt(provisi);
        params['cicilan'] = parseInt(cicilanCb.replaceAll('.', ''));
        var data = creditsSimulation.rumusCB(params);
        $("#tdpCb").val(creditsSimulation.convertToRupiah(data));
    }
});

function formatRupiah(angka, prefix) {
    var number_string = angka.replace(/[^,\d]/g, '').toString(),
        split = number_string.split(','),
        sisa = split[0].length % 3,
        rupiah = split[0].substr(0, sisa),
        ribuan = split[0].substr(sisa).match(/\d{3}/gi);

    if (ribuan) {
        var separator = sisa ? '.' : '';
        rupiah += separator + ribuan.join('.');
    }

    rupiah = split[1] != undefined ? rupiah + ',' + split[1] : rupiah;
    return prefix == undefined ? rupiah : (rupiah ? 'Rp. ' + rupiah : '');
}
